import { useMemo } from 'react';
import type { Location, View } from '@shared/types';
import { useMe, useStore } from '@/lib/store';
import { runQuery } from '@/lib/query';
import { spaceIdOfLocation } from '@/lib/hierarchy';

/** Runs the view engine; recomputes when tasks or hierarchy tables change. */
export function useViewQuery(view: View, location: Location, search: string, opts: { includeEmptyStatuses?: boolean; flatten?: boolean } = {}) {
  const me = useMe();
  const tasks = useStore((s) => s.db.tasks);
  const lists = useStore((s) => s.db.lists);
  const spaces = useStore((s) => s.db.spaces);
  const folders = useStore((s) => s.db.folders);
  const users = useStore((s) => s.db.users);
  const customFields = useStore((s) => s.db.customFields);
  const taskTypes = useStore((s) => s.db.taskTypes);
  const tags = useStore((s) => s.db.tags);
  return useMemo(() => {
    const db = useStore.getState().db;
    return runQuery(db, location, view.settings, { meId: me, search, includeEmptyStatuses: opts.includeEmptyStatuses, flatten: opts.flatten });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tasks, lists, spaces, folders, users, customFields, taskTypes, tags, view.settings, location.type, location.id, me, search, opts.includeEmptyStatuses, opts.flatten]);
}

/** Space used for tag pickers etc. Workspace-level views fall back to the task's own space. */
export function useLocationSpaceId(location: Location) {
  return useStore((s) => spaceIdOfLocation(s.db, location));
}
